export const aciCheckCircle = {
    iconName: 'check-circle',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 22 22' },
        path: [
            {
                attr: {
                    d: 'M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M15 7l-5.444 7.347a1.055 1.055 0 01-1.713.029L6 11.919',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
